import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from "vue";
import { ToastLevel } from "@/observables/store/toast-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicToast',
  props: {
  message: {
    type: String,
    required: true,
  },
  level: {
    type: String as PropType<ToastLevel>,
    required: true,
  },
},
  setup(__props) {

const className = computed(() => {
  return `alert alert-${props.level}`;
});

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(className.value)
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.$props.message), 1)
  ], 2))
}
}

})